<template>
  <blog-form :key="id" :blog-id="id" />
</template>

<script>
import BlogForm from "@/components/blogs/BlogForm.vue";

export default {
  name: "BlogUpdate",
  components: { BlogForm },
  props: {
    id: { type: [String, Number], required: true },
  },
};
</script>
